import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/parents";

export default createStore({ Model });
